import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PurchaseOrders_ds_reasoncodes_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { parentId: number, parentEntity: string, fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.parentId)) {
      missingRequiredInParams.push('\'parentId\'');
    }
    if (isNil(inParams.parentEntity)) {
      missingRequiredInParams.push('\'parentEntity\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PurchaseOrders/datasources/ds_reasoncodes_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { parentId: number, parentEntity: string, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.parentId)) {
      missingRequiredInParams.push('\'parentId\'');
    }
    if (isNil(inParams.parentEntity)) {
      missingRequiredInParams.push('\'parentEntity\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PurchaseOrders/datasources/ds_reasoncodes_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { parentId: number, parentEntity: string, fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.parentId)) {
      missingRequiredInParams.push('\'parentId\'');
    }
    if (isNil(inParams.parentEntity)) {
      missingRequiredInParams.push('\'parentEntity\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PurchaseOrders/datasources/ds_reasoncodes_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      parentId: number, parentEntity: string, fullTextSearch?: string    }) {
        if(isNil(inParams.parentId)) {
          return true; 
        }
        if(isNil(inParams.parentEntity)) {
          return true; 
        }
      return false;
    }
}
